import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Story from "./pages/Story";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceMapPage, { ServiceIndexPage } from "./pages/ServiceMap";
import EducationAcademics from "./pages/EducationAcademics";
import Industries from "./pages/Industries";
import Insights from "./pages/Insights";
import Store from "./pages/Store";
import Contact from "./pages/Contact";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import Admin from "./pages/Admin";

let lenis = null;

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el && lenis) lenis.scrollTo(el, { offset: -80 });
      }, 400);
      return () => clearTimeout(timer);
    }
    // hard reset: before, and again after Lenis's next rAF tick so it can't re-apply a stale position
    const reset = () => {
      if (lenis) {
        lenis.scrollTo(0, { immediate: true, force: true });
      }
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };
    reset();
    const t1 = setTimeout(reset, 60);
    const t2 = setTimeout(reset, 180);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="min-h-screen bg-cream text-charcoal">
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Story />} />
              <Route path="/classic" element={<Home />} />
              <Route path="/story" element={<Navigate to="/" replace />} />
              <Route path="/story/" element={<Navigate to="/" replace />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<ServiceMapPage />} />
              <Route path="/services/map" element={<Navigate to="/services" replace />} />
              <Route path="/services/index" element={<ServiceIndexPage />} />
              <Route path="/services/overview" element={<Services />} />
              <Route path="/education-academics" element={<EducationAcademics />} />
              <Route path="/education" element={<Navigate to="/education-academics" replace />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/store" element={<Store />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#0A1224", color: "#F3EEE6", border: "1px solid #1E2D4A" } }} />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
